module.exports = __webpack_public_path__ + "static/media/SellerboxGuideStore.c034b26b.png";